// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"679":"76e4247b","787":"5bfcc5ee"}[chunkId] + ".chunk.js";
};